import NotFound from './notfound.presenter';

export default function NotFoundPage() {
    return <NotFound />;
}
